import { afterRenderEffect, ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslocoService } from '@jsverse/transloco';
import { SnackBarComponent } from './snackbar.component';
import { SnackbarService } from '@dss-libs/shared/utility/common-services';
import { SystemLanguage } from '@dss-libs/shared/type/common-types';

@Component({
  selector: 'dss-libs-ui-snackbar-wrapper',
  imports: [],
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnackbarWrapperComponent {
  readonly #snackBar = inject(MatSnackBar);
  readonly #transloco = inject(TranslocoService);
  readonly #snackBarService = inject(SnackbarService);

  readonly snackbarEffect = afterRenderEffect({
    read: () => {
      const data = this.#snackBarService.snackbarSignal();
      if (data) {
        this.#snackBar.openFromComponent(SnackBarComponent, {
          data,
          duration: data.duration,
          panelClass: ['snackbar', `snackbar--${data.type.toLowerCase()}`],
          horizontalPosition: this.#transloco.getActiveLang() === SystemLanguage.Arabic ? 'left' : 'right',
          verticalPosition: 'top',
        });
      }
    },
  });
}
